import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';  
import { MatSelectModule} from '@angular/material/select';

import { ClickOutsideDirective } from './clickoutside.directive';
import { SpinnerDirective } from './spinner.directive';
import { GridStateDirective } from './gridState.directive';
import { PhoneMaskDirective } from './phone-number-mask.directive';
import { NumericOnlyDirective } from './numeric-only.directive';

@NgModule({
    exports: [
        CommonModule,
        ClickOutsideDirective,
        GridStateDirective,
        SpinnerDirective,
        PhoneMaskDirective,
        NumericOnlyDirective
    ],
    imports: [
        CommonModule,
        MatSelectModule,
        NumericOnlyDirective
    ],
    declarations: [
        ClickOutsideDirective,
        SpinnerDirective,
        GridStateDirective,
        PhoneMaskDirective
    ]
})
export class CommonDirectivesModule { }
